module.exports = __webpack_public_path__ + "media/col/favicon-c44f4b92.ico";